import React from 'react';
import style from './index.module.scss';

const ProductDetails = ({ details }:any) => (
  <div className={style.productDetailsContainer}>
    {details.description && (
      <div className={style.detailsContent}>
        <div className={style.detailsSubHead}>About this product</div>
        <div className={style.detailsDesc}>
          {details.description}
        </div>
        <div className="pb-4" />
      </div>
    )}

    <div className={` 
        ${style.detailsContainer}`}
    >

      {details.ingredients && (
      <div className={style.detailsContent}>
        <span className={style.detailsSubHead2}>Ingredients: </span>
        <span className={style.detailsDesc}>{details.ingredients}</span>
      </div>
      )}

      {details.nutitionalFacts && (
        <div className={style.detailsContent}>
          <span className={style.detailsSubHead2}>Nutritional Facts: </span>
          <span className={style.detailsDesc}>{details.nutitionalFacts}</span>
        </div>
      )}

      {details.otherProductInfo && (
        <div className={style.detailsContent}>
          <span className={style.detailsSubHead2}>Other Product Info: </span>
          <span className={style.detailsDesc}>{details.otherProductInfo}</span>
        </div>
      )}

      {details.moreInfo && (
      <div className={style.detailsContent}>
        <div className={style.detailsSubHead2}>More Product Info: </div>
        <div className={style.detailsDesc}>
          {Object.keys(details.moreInfo).map((item:any) => (
            <div className={style.moreInfo}>
              {item}
              {' '}
              :
              {' '}
              <span>{details.moreInfo[item]}</span>
            </div>
          ))}
        </div>
      </div>
      )}
    </div>
  </div>
);

export default ProductDetails;
